var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-back-top',{staticClass:"custom-back-up",attrs:{"visibility-height":_vm.visibilityHeight},model:{value:(_vm.$props),callback:function ($$v) {_vm.$props=$$v},expression:"$props"}},[_c('div',{staticClass:"custom-back-up__icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }